import { render, staticRenderFns } from "./ReviewerName.vue?vue&type=template&id=8deee478&"
import script from "./ReviewerName.vue?vue&type=script&lang=js&"
export * from "./ReviewerName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8deee478')) {
      api.createRecord('8deee478', component.options)
    } else {
      api.reload('8deee478', component.options)
    }
    module.hot.accept("./ReviewerName.vue?vue&type=template&id=8deee478&", function () {
      api.rerender('8deee478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/outputs/ReviewerName.vue"
export default component.exports